import { useCallback, useState } from "react";

interface FilterState {
	[key: string]: string[];
}

function useFilterCheckbox(initialFilters?: FilterState) {
	const [filterMode, setFilterMode] = useState(false);
	const [hideExcluded, setHideExcluded] = useState<any>(true);

	// Initialize selectedFilters dynamically based on provided initial filters
	const [selectedFilters, setSelectedFilters] = useState<FilterState>(() => {
		if (initialFilters) {
			// Create a deep copy with empty arrays for each filter field
			const defaultFilters: FilterState = {};
			Object.keys(initialFilters).forEach((key) => {
				defaultFilters[key] = [];
			});
			return defaultFilters;
		}
		return {};
	});

	const handleMenuClick = useCallback(
		(field: string, selectedValues: string[]) => {
			setSelectedFilters((prev: FilterState) => ({
				...prev,
				[field]: selectedValues,
			}));
		},
		[]
	);

	const handleClearAllFilters = useCallback(() => {
		// Reset all filters to empty arrays instead of empty object
		const resetFilters: FilterState = {};
		Object.keys(selectedFilters).forEach((key) => {
			resetFilters[key] = [];
		});
		setSelectedFilters(resetFilters);
	}, [selectedFilters]);

	// Add a filter field dynamically
	const addFilterField = useCallback((field: string) => {
		setSelectedFilters((prev: FilterState) => ({
			...prev,
			[field]: prev[field] || [],
		}));
	}, []);

	// Remove a filter field
	const removeFilterField = useCallback((field: string) => {
		setSelectedFilters((prev: FilterState) => {
			const newFilters = { ...prev };
			delete newFilters[field];
			return newFilters;
		});
	}, []);

	return {
		filterMode,
		setFilterMode,
		hideExcluded,
		setHideExcluded,
		selectedFilters,
		handleMenuClick,
		handleClearAllFilters,
		addFilterField,
		removeFilterField,
	};
}

export default useFilterCheckbox;
